export const testimonials = [
  {
    name: "阿梨",
    school: "江城大学 · 大四",
    text: "以前要翻三个群才能知道学校发生了什么，现在打开首页热搜榜就全看见了，省下来的时间都能用来复习。",
  },
  {
    name: "小舟",
    school: "明湖理工 · 大三",
    text: "最喜欢它的每日精选，基本都是有信息量的长帖，不是那种一句话就没了的水贴，看得很过瘾。",
  },
  {
    name: "Nina",
    school: "云麓师范大学 · 大二",
    text: "筛选学校的功能很实用，我们这种小学校也能有自己的板块，感觉被认真对待了。",
  },
  {
    name: "老陈",
    school: "白鹭财经大学 · 研一",
    text: "作为一个已经毕业的人，偶尔回来看看学弟学妹在聊什么，还挺有代入感的，内容质量比想象中高。",
  },
];

export const communityStats = [
  { label: "收录高校", value: "1280+", icon: "ri-building-2-line" },
  { label: "日增帖子", value: "3400+", icon: "ri-chat-new-line" },
  { label: "活跃讨论区", value: "96", icon: "ri-discuss-line" },
  { label: "每日精选话题", value: "20", icon: "ri-star-smile-line" },
];